

























































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { AppContainer, TYPES } from "@/app/index";
import { IEntityList } from "@/interfaces";
import {
  ConfigService,
  AppointmentService,
  ItemsService,
  VisitourService
} from "@/services";
import {
  Appointment,
  Branding,
  ItemsGroupedByItemDescription,
  NotificationTemplateNotificationType,
  ShowCallInfoResponse,
  ShowCallInfoResultState,
  ShowCallInfoResultSaveStatus,
  ShowCallResponse,
  DataSet,
} from "@/models";
import ItemInformation from "./ItemInformation.vue";
import RescheduleDateInformation from "./RescheduleDateInformation.vue";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

@Component({
  components: {
    ItemInformation,
    RescheduleDateInformation
  }
})
export default class AppointmentInformation extends Vue {
  private configService: ConfigService = AppContainer.get<ConfigService>(TYPES.Services.ConfigService);
  private AppointmentService: AppointmentService = AppContainer.get<AppointmentService>(TYPES.Services.AppointmentService);
  private ItemsService: ItemsService = AppContainer.get<ItemsService>(TYPES.Services.ItemsService);
  private VisitourService: VisitourService = AppContainer.get<VisitourService>(TYPES.Services.VisitourService);
  private flsItem: ItemsGroupedByItemDescription | null = null;
  private groupedItemsDataSet: DataSet<ItemsGroupedByItemDescription> = new DataSet();
  private appointmentCanBeCancelled: boolean = false;
  private appointmentCanBeConfirmed: boolean = false;
  private appointmentIsConfirmed: boolean = false;
  private arrivalWindow: string | null = null;
  private arrivalDates: Array<Date> = [];
  private hasNotificationsAGradeUnscheduledAppointmentNotification1: boolean = false;
  private hasNotificationsUnscheduledAppointmentNotification1: boolean = false;
  private hasThoroughItems: boolean = false;
  private hasInterimItems: boolean = false;
  private hasAGradePressureItem: boolean = false;
  private requiresServiceEngineer: boolean = false;
  private requiresSupplementaryTest: boolean = false;
  private appointmentCanBeChanged: boolean = false;
  private reference: string = null;
  private appointment: Appointment | null = null;
  private showCallInfoResponse: ShowCallInfoResponse | null = null;
  private showCallResponse: ShowCallResponse | null = null;
  private showItemInfo: boolean = false;
  private errorMessage: string | null = null;
  private BrandingType: number = 0;
  private Branding = Branding;
  private appointmentCalendarICSURL: string;
  private appointmentCalendarGoogleURL: string;
  private appointmentCalendarOutlookURL: string;
  private appointmentCalendarOffice365URL: string;
  private initialDate: Date = null;

  private groupedItemsFields: any = [
    { key: "HasInterimItem", label: "", tdClass: "text-center", thStyle: { "width" : "80px" } },
    { key: "HasThoroughItem", label: "", tdClass: "text-center", thStyle: { "width" : "80px" } },
    { key: "ServiceEngineerRequired", label: "", tdClass: "text-center", thStyle: { "width" : "80px" } },
    { key: "SupplementaryTestRequired", label: "", tdClass: "text-center", thStyle: { "width" : "80px" } },
    { key: "SuperCallNumber", label: "Super Call Number", thClass: "d-none", tdClass: "d-none" },
    { key: "ItemDescription", label: "Item Description", thStyle: { "min-width": "400px" } },
    { key: "Quantity", label: "Quantity", tdClass: "text-center", thStyle: { "width": "100px" } },
    { key: "ItemInformation", label: "Item Information", tdClass: "text-center", thStyle: { "width": "150px" } }
  ];

  public created(): void {
    this.setBranding();

    this.reference = this.$route.query.ref.toString();
    this.AppointmentService.GetAppointmentByKey(this.reference)
      .then(response => {
        this.appointment = response.data;

        this.AppointmentService.GetAppointmentCalendarICSURL(this.reference).then(response => { this.appointmentCalendarICSURL = response.data; });
        this.AppointmentService.GetAppointmentCalendarGoogleURL(this.reference).then(response => { this.appointmentCalendarGoogleURL = response.data; });
        this.AppointmentService.GetAppointmentCalendarOutlookURL(this.reference).then(response => { this.appointmentCalendarOutlookURL = response.data; });
        this.AppointmentService.GetAppointmentCalendarOffice365URL(this.reference).then(response => { this.appointmentCalendarOffice365URL = response.data; });

        switch (this.$route.query.source) {
          case "admin":
        /* Ignore */ break;
          default:
            this.AppointmentService.SetAccessedDate(this.reference);
            break;
        }

        this.loadShowCallInfo();

        this.groupedItemsDataSet.Configure(dataSet => {
          this.groupedItemsDataSet.Page.RecordsPerPage = 100;
          this.ItemsService.GetRecords<IEntityList<ItemsGroupedByItemDescription>>(
            `/GetItemsGroupedByItemDescription?superCallNumber=${encodeURIComponent(
              this.appointment.ExtID
            )}&branding=${this.BrandingType}&skip=${dataSet.Page.Skip}&take=${dataSet.Page.RecordsPerPage}`
          )
            .then(response => {
              dataSet.DataLoadedCallback(
                response.data.Entities,
                response.data.Total
              );
            })
            .catch(error => {
              dataSet.DataLoadFailedCallback();
              this.errorMessage = "Oops, something went wrong, please try again later or call us on 0345 072 4387 (Monday to Friday, 8am to 5pm).";
            });
        });
        this.groupedItemsDataSet.Load();
      })
      .catch(error => {
        this.errorMessage = "Oops, something went wrong, the page you’re looking for doesn’t exist or can’t be found.";
      });

    if (this.configService.Config.FLSItemsPreparationVisible) {
      if (!this.groupedItemsFields.find((gif: any) => gif.key === "PreperationInstructions")) {
        this.groupedItemsFields.push(
          { key: "PreparationInstructions", label: "Preparation Instructions", tdClass: "text-center",  thStyle: { "width": "150px" } }
        );
      }
    }
  }

  private loadShowCallInfo() {
    this.VisitourService.ShowCallInfo(this.appointment.ExtID)
      .then(response => {
        this.showCallInfoResponse = response.data;
        if (this.showCallInfoResponse != null && this.showCallInfoResponse.ShowCallInfoResult !== null) {
          this.AppointmentService.AppointmentCanBeCancelled(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID
          ).then(response => {
            this.appointmentCanBeCancelled = response.data;
          });

          this.AppointmentService.AppointmentCanBeChanged(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID
          ).then(response => {
            this.appointmentCanBeChanged = response.data;
          });

          this.AppointmentService.AppointmentCanBeConfirmed(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID
          ).then(response => {
            this.appointmentCanBeConfirmed = response.data;
          });

          this.AppointmentService.AppointmentArrivalWindow(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID
          ).then(response => {
            this.arrivalWindow = response.data;
          });

          this.AppointmentService.AppointmentHasNotifications(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID,
            NotificationTemplateNotificationType.AGradePressureItemUnscheduledAppointmentNotification1
          ).then(response => {
            this.hasNotificationsAGradeUnscheduledAppointmentNotification1 = response.data;
          });

          this.AppointmentService.AppointmentHasNotifications(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID,
            NotificationTemplateNotificationType.UnscheduledAppointmentNotification1
          ).then(response => {
            this.hasNotificationsUnscheduledAppointmentNotification1 = response.data;
          });

          this.AppointmentService.AppointmentHasThoroughItems(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID,
            this.BrandingType
          ).then(response => {
            this.hasThoroughItems = response.data;
          });

          this.AppointmentService.AppointmentHasInterimItems(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID,
            this.BrandingType
          ).then(response => {
            this.hasInterimItems = response.data;
          });

          this.AppointmentService.AppointmentHasAGradePressureItem(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID
          ).then(response => {
            this.hasAGradePressureItem = response.data;
          });

          this.AppointmentService.AppointmentRequiresServiceEngineer(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID
          ).then(response => {
            this.requiresServiceEngineer = response.data;
          });

          this.AppointmentService.AppointmentRequiresSupplementaryTest(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID
          ).then(response => {
            this.requiresSupplementaryTest = response.data;
          });

          this.AppointmentService.AppointmentIsConfirmed(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID
          ).then(response => {
            this.appointmentIsConfirmed = response.data;
          });

          this.VisitourService.GetSchedule(
            this.showCallInfoResponse.ShowCallInfoResult.ExtID
          ).then(response => {
            if (response.data.GetScheduleResult.length > 1) {
              this.arrivalDates = response.data.GetScheduleResult.map(function (scheduledCall) {
                return new Date(scheduledCall.Date);
              });
            } else {
              this.arrivalDates = [new Date(this.showCallInfoResponse.ShowCallInfoResult.Arrival)];
            }
            this.SetInitialDate();
          });
        }
      })
      .catch(error => {
        this.errorMessage = "Oops, something went wrong, please try again later or call us on 0345 072 4387 (Monday to Friday, 8am to 5pm).";
      });
  }

  private showCancelMessage() {
    (this.$refs.tempCancelModal as any).show();
    this.AppointmentService.CancelAppointment(this.reference);

    /*
      // When actual cancellation is enabled, remove the section above and uncomment this section.
      // Also uncomment the commented section of AppointmentController.CancelAppointment

      (this.$refs.cancelModal as any).show();
    */
  }

  public CancelAppointment(): any {
    (this.$refs.CancelAppointmentModal as any).show();
    this.AppointmentService.CancelAppointment(this.reference)
      .then(response => {
        this.showCallInfoResponse = response.data;
        (this.$refs.AppointmentCancelledModal as any).show();
      })
      .catch(error => {
        (this.$refs.AppointmentErrorModal as any).show();
      })
      .finally(() => {
        (this.$refs.ConfirmAppointmentModal as any).hide();
      });
  }

  private showConfirmMessage() {
    (this.$refs.confirmModal as any).show();
  }

  private showRescheduleDate() {
    (this.$refs.RescheduleDateModal as any).show();
  }

  public ConfirmAppointment(): any {
    (this.$refs.ConfirmAppointmentModal as any).show();
    this.AppointmentService.ConfirmAppointment(this.reference)
      .then(response => {
        this.showCallInfoResponse = response.data;
        (this.$refs.AppointmentSuccessModal as any).show();
      })
      .catch(error => {
        (this.$refs.AppointmentErrorModal as any).show();
      })
      .finally(() => {
        (this.$refs.ConfirmAppointmentModal as any).hide();
        this.loadShowCallInfo();
      });
  } 

  /**
   * Highlights arrival dates.
   * For more detail see https://bootstrap-vue.org/docs/components/calendar#adding-css-classes-to-specific-dates
   * @param {string} ymd The date as a YYYY-MM-DD string.
   * @param {date} date The date as a Date object.
   */
  public HighlightArrivalDates(ymd: any, date: any) {
    return this.arrivalDates.some(ad => ad.getUTCFullYear() === date.getFullYear() && ad.getUTCMonth() === date.getMonth() && ad.getUTCDate() === date.getDate()) ? 'table-primary' : '';
  }

  private SetInitialDate() {
    var arrivalDate = this.GetEarliestDate(this.arrivalDates);
    var today = new Date();
    this.initialDate = arrivalDate.getUTCFullYear() === today.getUTCFullYear() && arrivalDate.getUTCMonth() === today.getUTCMonth() ? new Date(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()) : new Date(Date.UTC(arrivalDate.getUTCFullYear(), arrivalDate.getUTCMonth(), 1));
  }

  // Item Information
  private ShowItemInfo(record: any) {
    if (this.flsItem === record) {
      this.showItemInfo = false;
      this.flsItem = null;
    } else {
      this.flsItem = record;
      this.showItemInfo = true;
      this.$nextTick(() => {
        if (this.showItemInfo) {
          document.getElementById('ItemInformationCard').scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  private OnItemInformationClosed() {
    this.showItemInfo = false;
    this.flsItem = null;
  }

  // Preparation Instructions
  private ViewPreparationInstructions(record: any) {
    (this.$refs.entityPreparationInstructions as any).show();
  }

  private OnAppointmentReschedule(appointmentDate: Date) {
    this.loadShowCallInfo();
    (this.$refs.RescheduleDateModal as any).hide();
  }

  private setBranding() {
    if (this.BrandingType === 0) {
      var currentURL = window.location.hostname.toLowerCase();

      switch (true) {
        case this.configService.Config.BrandingURLBES !== "" && currentURL.includes(this.configService.Config.BrandingURLBES):
          this.BrandingType = this.Branding.BES;
          break;
        case this.configService.Config.BrandingURLVulcan !== "" && currentURL.includes(this.configService.Config.BrandingURLVulcan):
        case this.$route.query.branding && this.$route.query.branding.toString().toLowerCase() === "vulcan":
          this.BrandingType = this.Branding.Vulcan;
          break;
        default:
          this.BrandingType = this.Branding.BES;
          break;
      }
    }
  }

  private GetEarliestDate(dates: Array<Date>) {
    // Ignore typsecript check as it causes a build failure expecting that Math.min() can only run on number types and not Date types.
    // @ts-ignore
    return new Date(Math.min(...dates));
  }

  private UnscheduledAppointment() {
    var currentlyUnscheduled = this.showCallInfoResponse.ShowCallInfoResult.Arrival === null || new Date(this.showCallInfoResponse.ShowCallInfoResult.Arrival) < new Date(2000, 1, 1);
    var previouslyUnscheduled = this.hasNotificationsUnscheduledAppointmentNotification1 || this.hasNotificationsAGradeUnscheduledAppointmentNotification1;
    var currentlyConfirmed = this.showCallInfoResponse.ShowCallInfoResult.State === ShowCallInfoResultState.Confirmed || (this.showCallInfoResponse.ShowCallInfoResult.State === ShowCallInfoResultState.Fixed && this.showCallInfoResponse.ShowCallInfoResult.SaveStatus === ShowCallInfoResultSaveStatus.Confirmed);
    return currentlyUnscheduled || (previouslyUnscheduled && !currentlyConfirmed);
  }
}
